module.exports = __webpack_public_path__ + "static/media/client-10.d2acfe3f.jpg";